import { Close, RocketLaunch, TaskAlt } from '@mui/icons-material'
import { Box, Button, IconButton, LinearProgress, List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ToolContext } from '../../../../core/context/ToolContext'
import { rqx } from '../../../../core/request/API'
import { env } from '../../../../core/Env'

const Index = () => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION, personalization } = tool_state

    const [taskStatus, setTaskStatus] = useState(null)
    const [progressValue, setProgressValue] = useState(0)

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8)  

    const task = [
        {label: 'Coment', description: 'Coment atleast 1 in Article, News, Updates', status: taskStatus?.comment, path: '/psl/publication?tab=article', action: ''},
        {label: 'Like', description: 'Like atleast 1 in Article, News, Updates', status: taskStatus?.reaction, path: '/psl/publication?tab=article', action: ''},
        {label: 'Save', description: 'Save atleast 1 in Article, News, Updates', status: taskStatus?.save, path: '/psl/publication?tab=article', action: ''},
        {label: 'Read', description: 'Read atleast 1 in Article, News, Updates', status: taskStatus?.views, path: '/psl/publication?tab=article', action: ''},
    ]

    const openHandler = () => {
        personalization.set(prev => ({ ...prev, startHere: !prev.startHere }))
    }

    const __runTask = async () => {
        let data = await rqx.get(`<<tool>>/${env()}/psl/start/read`, {user_id: user_id})
        setTaskStatus(data)
    }

    const calculateProgress = ()=>{
            const taskDone = task.filter(v => v.status === 'done')
            setProgressValue(taskDone.length / task.length * 100)
        }
    
    useEffect(() => {
        __runTask()
        calculateProgress()
        // eslint-disable-next-line
    }, [personalization.data.startHere])

    return task.filter(v => v.status === 'proceed').length > 0 ? (
        <Box
            position="absolute"
            right={40}
            bottom={30}
            display="flex"
            alignItems="flex-end"
            flexDirection="column"
            gap="16px"
        >
            <Box
                sx={{
                    width:"407px",
                    background: '#FFFFFF',
                    borderRadius:"12px",
                    p: '16px',
                    display:"flex" ,
                    flexDirection:"column" ,
                    gap:"16px",
                    transform: personalization.data.startHere ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.98)',
                    opacity: personalization.data.startHere ? 1 : 0,
                    transition: 'all 0.3s ease-in-out',
                    pointerEvents: personalization.data.startHere ? 'auto' : 'none',
                    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08)',
                    border: '1px solid #f5f5f5'
                }}
            >
                <Box display="flex" flexDirection="column" gap="12px">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box fontSize="16px" fontWeight="600">Stsrt here</Box>
                        <IconButton onClick={() => openHandler()} sx={{p: '8px'}}>
                            <Close sx={{fontSize: '18px'}}/>
                        </IconButton>
                    </Box>
                    <Box fontSize="14px">Complete these steps to unlock all the benefits and get the most out of Philtaxes.</Box>
                </Box>
                <Box display="flex" alignItems="center" gap="12px" >
                    <Box fontSize="16px" fontWeight="600">{`${progressValue}%`}</Box>
                    <LinearProgress
                        variant="determinate"
                        value={progressValue}
                        sx={{
                            width: '100%',
                            height: 8,
                            borderRadius: 10,
                            background: '#E7E8EA',
                            [`& .MuiLinearProgress-bar`]: {
                                borderRadius: 10,
                                background: '#453FBA'
                            }
                        }}
                    />
                </Box>
                <List disablePadding>
                    {
                        task.map((v, i) => (
                            <ListItem
                                key={i}
                                sx={{background: '#FBFCFB', my: '4px'}}
                                secondaryAction={ 
                                    v.status === 'proceed' ? 
                                        <Button onClick={() => openHandler()} disableElevation sx={{background: '#E7E8EA', borderRadius: '4px', fontSize: '12px', color: '#292C2F', '&:hover':{background: '#E7E8EA'}}}>
                                            Proceed
                                        </Button>
                                    :
                                        <Box display="flex" alignItems="center" gap="8px">
                                            <Box fontSize="12px" color="#22A06B">Done</Box>
                                            <TaskAlt sx={{color: '#22A06B', fontSize: '18px'}}/>
                                        </Box>
                                }
                                disablePadding
                            >
                                <ListItemButton sx={{py: '12px', borderRadius: '6px'}}>
                                    <ListItemText 
                                        primary={<Box fontSize="14px">{v.label}</Box>}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))
                    }
                </List>
            </Box>

            <Button
                onClick={openHandler}
                disableElevation
                variant="contained"
                sx={{
                    background: '#453FBA !important',
                    color: '#fff',
                    borderRadius: '100px',
                    padding: '12px 16px',
                }}
                startIcon={personalization.data.startHere ? <Close /> : <RocketLaunch />}
            >
                {personalization.data.startHere ? 'Close' : 'Start Here'}
            </Button>
        </Box>
    ) : null
}

export default Index
